import { render, staticRenderFns } from "./detailReferral.vue?vue&type=template&id=0fae0f4d&scoped=true"
import script from "./detailReferral.vue?vue&type=script&lang=js"
export * from "./detailReferral.vue?vue&type=script&lang=js"
import style0 from "./detailReferral.vue?vue&type=style&index=0&id=0fae0f4d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fae0f4d",
  null
  
)

export default component.exports